import { useQuery } from "@tanstack/react-query";
import { getClaimRequestTypes } from "../api/claimRequestTypeApi";
import { ExtractFnReturnType, QueryConfig } from "../../../../lib/react-query";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { PaginationFilterDto } from "../../../../types/Pagination";

type QueryFnType = typeof getClaimRequestTypes;

type UseSearchClaimRequestTypesOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useClaimRequestTypes = ({ config }: UseSearchClaimRequestTypesOptions = {}) => {
    const selectedFilters = useSelector((state: RootState) => state.filters.claimRequestTypes.selectedFilters);
    const pagination = useSelector((state: RootState) => state.historical.claimRequestTypes);
    const filterByOnlyActiveRecords = useSelector((state: RootState) => state.filters.claimRequestTypes.filterByOnlyActiveRecords);

    const paginationFilters: PaginationFilterDto =
    {
        pageNumber: pagination.currentPage,
        pageSize: pagination.itemsPerPage,
        search: pagination.searchText,
        filterByOnlyActiveRecords: filterByOnlyActiveRecords,
        filters: selectedFilters,
        selectedOrganizationalStructureIds: []
    };

    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ['getClaimRequestTypes', selectedFilters, pagination, filterByOnlyActiveRecords],
        queryFn: () => getClaimRequestTypes(paginationFilters),
    });
};